import { useEffect, useState, useCallback } from 'react'
import { useAppSelector } from 'hooks/useAppSelector'
import { ClientType } from 'storeTypes'
import { constants } from 'helpers/constants'
import { useSearchParams } from 'react-router-dom'
import { getStorage } from 'helpers'

const getLocalClient = (clientId?: string) => {
    const localClient = getStorage(constants.CLIENT_DETAIL_LOCAL_STORE)

    if (localClient?.client_code === clientId) {
        return localClient
    }

    return null
}

// TODO: Consolidate client details data from all sources:
// Redux -
//   * villageClientList.clientData (IndexedDB)
//   * singleClient.client (HTTP)
//   * updatePackages.enrollmentPayload
// localStorage -
//   * constants.CLIENT_DETAIL_LOCAL_STORE
//   * constants.CLIENT_FOR_ENROLLMENT_STORE
//   * constants.CLIENT_FOR_VISIT_STORE
export const useGetClient = (selectedClient: ClientType, clientId?: string) => {
    const [searchParams, setSearchParams] = useSearchParams()
    const [client, setClient] = useState<ClientType>(getLocalClient(clientId))

    const { enrollmentPayload } = useAppSelector(
        (state) => state.enrollment?.updatePackages
    )
    const { loading: loadingClient, clientList: singleClient } = useAppSelector(
        (state) => state.singleClient || { loading: false, clientList: [] }
    )

    const updateClient = useCallback((updatedClient: ClientType) => {
        setClient(updatedClient)

        localStorage.setItem(
            constants.CLIENT_DETAIL_LOCAL_STORE,
            JSON.stringify(updatedClient)
        )
    }, [])

    useEffect(() => {
        if (
            enrollmentPayload?.client_code &&
            enrollmentPayload?.client_code === clientId
        ) {
            updateClient({
                ...enrollmentPayload,
                ...client,
                allEnrollment: enrollmentPayload.all_enrollment,
                fullname: `${enrollmentPayload.firstname} ${enrollmentPayload.lastname}`,
                zone: enrollmentPayload.zone
            })
        }
    }, [enrollmentPayload])

    useEffect(() => {
        const foundClient = singleClient?.find(
            (client: ClientType) => client.client_code === clientId
        )

        if (foundClient) {
            searchParams.delete('reload')
            setSearchParams(searchParams)

            updateClient({
                ...foundClient,
                fullname: `${foundClient.firstname} ${foundClient.lastname}`
            })
        }
    }, [loadingClient, singleClient])

    useEffect(() => {
        if (
            selectedClient &&
            selectedClient.client_code &&
            selectedClient.client_code !== client?.client_code &&
            selectedClient.client_code === clientId
        ) {
            updateClient({
                ...selectedClient,
                fullname: `${selectedClient.firstname} ${selectedClient.lastname}`
            })
        }
    }, [selectedClient])

    return {
        client,
        updateClient,
        loadingClient
    }
}
